/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Data_1Inputs */

const da_terms_data_1 = /** @type {(inputs: Terms_Data_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skoler, der bruger tjenesten med elevdata, skal indgå en databehandleraftale med os. Se [privatlivspolitikken](/privacy).`)
};

/** @type {(inputs: Terms_Data_1Inputs) => LocalizedString} */
const en_terms_data_1 = da_terms_data_1;

/**

* @param {Terms_Data_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_data_1 = /** @type {((inputs?: Terms_Data_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Data_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_data_1(inputs)
	return /** @type {LocalizedString} */ ("Skoler, der bruger tjenesten med elevdata, skal indgå en databehandleraftale med os. Se [privatlivspolitikken](/privacy).")
});